import { FiGrid } from 'react-icons/fi';
import { HiViewList } from 'react-icons/hi';
import { colorToRgba } from '../../../../../../../../utils/helper/Helper';
import { RavenToolTip } from '@ravenpay/raven-bank-ui';

type View = 'grid' | 'table';
type ViewToggleProps = {
	view: View;
	onchangeView: (view: View) => void;
	baseColor: string;
};

const ViewToggle = ({ view, onchangeView, baseColor }: ViewToggleProps) => {
	return (
		<div
			className="view-toggle grey-bg"
			style={{
				backgroundColor: colorToRgba(baseColor!, 0.1),
			}}
		>
			<div
				className={`view-toggle__button ${
					view === 'grid' ? 'view-toggle__button--active' : ''
				}`}
				onClick={() => onchangeView('grid')}
				style={{
					backgroundColor: view === 'grid' ? baseColor! : 'transparent',
				}}
			>
				<FiGrid size={16} color={view === 'grid' ? '#fff' : baseColor!} />
			</div>

			<div
				className={`view-toggle__button ${
					view === 'table' ? 'view-toggle__button--active' : ''
				}`}
				onClick={() => onchangeView('table')}
				style={{
					backgroundColor: view === 'table' ? baseColor! : 'transparent',
				}}
			>
				<HiViewList size={16} color={view === 'table' ? '#fff' : baseColor!} />
			</div>
		</div>
	);
};

export default ViewToggle;
